import './style.css'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import Experience from './Experience.jsx'
import Placeholder from './Placeholder.jsx'
// import studio from "@theatre/studio";
// import extension from "@theatre/r3f/dist/extension";

// studio.extend(extension);
// studio.initialize();

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    <React.StrictMode>
        <Suspense fallback={ <Placeholder /> }>
            <Experience />
        </Suspense>
    </React.StrictMode>
)